/**
 * 观看历史相关接口
 */

import { post, ApiResponse } from './api';
import { API_PATHS } from './apiPaths';

/**
 * 查询观看历史列表
 */
export async function queryHistory(body?: any, params?: any): Promise<ApiResponse<any>> {
  return post(API_PATHS.GetRPCQueryHistory, body, { params });
}

/**
 * 查询观看历史 UI 数据（海报）
 */
export async function queryHistoryUiData(body?: any, params?: any): Promise<ApiResponse<any>> {
  return post(API_PATHS.GetRPCQueryHistoryUiData, body, { params });
}

/**
 * 同步服务器时间
 */
export async function syncTime(body?: any, params?: any): Promise<ApiResponse<any>> {
  return post(API_PATHS.RPCSyncTime, body, { params });
}

/**
 * 上报观看历史（删除单个）
 */
export async function reportHistory(body?: any, params?: any): Promise<ApiResponse<any>> {
  return post(API_PATHS.RPCReportHistory, body, { params });
}

/**
 * 上报删除全部观看历史
 */
export async function deleteAllHistory(body?: any, params?: any): Promise<ApiResponse<any>> {
  return post(API_PATHS.RPCReportDelAllHistory, body, { params });
}

/**
 * 查询单个历史记录（断点续播）
 */
export async function getLastPlay(body?: any, params?: any): Promise<ApiResponse<any>> {
  return post(API_PATHS.lastPlay, body, { params });
}

/**
 * 上报观看历史（播放记录）
 */
export async function reportHistoryPlay(body?: any, params?: any): Promise<ApiResponse<any>> {
  return post(API_PATHS.historyReport, body, { params });
}

/**
 * 获取历史记录cid封面信息
 */
export async function getHistoryCidCover(body?: any, params?: any): Promise<ApiResponse<any>> {
  return post(API_PATHS.GetCoverInfo, body, { params });
}
